<template>
    <div class="qksm qksm6">
        <h4>六、财政拨款基本支出决算情况说明</h4>
        <div class="nogap">
            <p>
                2021年度财政拨款基本支出决算{{isMoney(T6.合计)}}万元，其中：
            </p>
            <p>
                <b>（一）人员经费{{isMoney(T6.人员经费)}}万元。</b>主要包括：{{num(T6.人员经费)==0 ? "无" : T6.人员经费包括.join('、')}}。
            </p>
            <p>
                <b>（二）公用经费{{isMoney(T6.公用经费)}}万元。</b>主要包括：{{num(T6.公用经费)==0 ? "无" : T6.公用经费包括.join('、')}}。
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "qksm6",
        props: {
            T6: {
                type: Object,
                default: "",
            },
        },
        data() {
            if (this.num(this.T6.合计).toFixed(2) !=this.num(this.T6.人员经费+this.T6.公用经费).toFixed(2)) {
                this.addOrSet("qksm6", "请检查本页《六、财政拨款基本支出决算情况说明》及第六张公开表，人员经费与公用经费之和与财政拨款基本支出总数不相等。");
            } else {
                this.remove("qksm6")
            }
            return {
                isPdf: this.$parent.isPdf
            }
        },
    };
</script>